var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad)?_c(_vm.name,{key:_vm.updateKey,tag:"component",attrs:{"ad":_vm.ad}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }